export class Validation {
  constructor(constraints = []) {
    this.constraints = constraints;
  }

  test = (value) => {
    if (value === "") {
      this.reset();
      return;
    }

    let invalidCount = 0;
    this.constraints.forEach(c => {
      c.test(value) || invalidCount++;
    });

    return invalidCount === 0;
  }

  reset = () => {
    this.constraints.forEach(c => c.setState());
  }

  getState = () => {
    if (this.hasError()) {
      return "error";
    } else if (this.passAllConstraints()) {
      return "success";
    } else {
      return;
    }
  }

  hasError = () => {
    return this.constraints.some(c => c.state === "error");
  }

  passAllConstraints = () => {
    return this.constraints.every(c => c.state === "success");
  }
}

export default Validation;


// WEBPACK FOOTER //
// ./src/models/Validation.js